import { DeviceChecker } from './deviceChecker';
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const deviceChecker = new DeviceChecker();

/**
 * アコーディオンを管理するクラス。
 */
export class Accordion {
    /**
     * アコーディオンのインスタンスを作成。
     * @param {string|jQuery} selector - アコーディオンのセレクタまたはjQueryオブジェクト。
     * @param {string} [pattern='pt01'] - アコーディオンのパターン。デフォルトは 'pt01'。
     */
    constructor(selector, pattern = 'pt01') {
        this.$accordion = $(selector);
        this.$gnavAccordionElem = $('.l-header_gnav > ul > li > a');
        this.$items = this.$accordion.find('.accordion_item');
        this.pattern = pattern;

        this._init();
    }

    /**
     * アコーディオンアイテムのイベントハンドラを初期化。
     * @private
     */
    _init() {
        this.$items.each((index, element) => {
            const $header = $(element).find('.js-accordion_header');
            const $content = $(element).find('.js-accordion_content');

            // WAI-ARIA 属性の設定
            $header.attr('aria-expanded', 'false');
            $content.attr({
                'role': 'region',
                'aria-hidden': 'true',
            });

            $header.on('click', () => {
                this._toggle(element);
            });

            // キーボード操作を追加
            $header.on('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    this._toggle(element);
                }
            });
        });

        $(window).on('load resize', deviceChecker._debounce(() => {
            if (deviceChecker._isMobile()) {
                this.$gnavAccordionElem.off().on('click', (e) => {
                    this._gnavAccordion(e);
                });
            } else {
                this.$gnavAccordionElem.off('click');
            }
        }, 200));
    }

    /**
     * アコーディオンアイテムのコンテンツをトグル。
     * @param {HTMLElement} item - トグルするアコーディオンアイテム。
     * @private
     */
    _toggle(item) {
        const $item = $(item);
        const $header = $item.find('.js-accordion_header');
        const $content = $item.find('.js-accordion_content');
        const isVisible = $content.is(':visible');

        $content.slideToggle(500, () => {
            if (!isVisible) {
                this._scroll($item);
            }
        });

        $item.toggleClass('is-active');
        $header.toggleClass('is-open');

        // WAI-ARIA 属性の更新
        $header.attr('aria-expanded', !isVisible);
        $content.attr('aria-hidden', isVisible);

        if (this.pattern === 'pt02') {
            this.$items.not($item).find('.js-accordion_content').slideUp();
            this.$items.not($item).find('.js-accordion_header').attr('aria-expanded', 'false');
            this.$items.not($item).find('.js-accordion_content').attr('aria-hidden', 'true');
        }
    }

    /**
     * アコーディオンアイテムまでスクロール。
     * @param {HTMLElement} item - スクロールするアコーディオンアイテム。
     * @private
     */
    _scroll(item) {
        const $item = $(item);
        const headerHeight = $('header').height();
		gsap.to(window, {
            duration: 1,
            ease: "power3.inOut",
            scrollTo: {
            y: $item,
            offsetY: headerHeight,
            autoKill: true
            }
		});
    }

    /**
     * グローバルナビゲーションのアコーディオンの処理を行う。
     * @param {Event} e - クリックイベント。
     * @private
     */
    _gnavAccordion(e) {
        e.preventDefault();
        this.$gnavAccordionElem.next().slideToggle();
    }
}